import { Link } from "react-router-dom";
import methodModel from "../../../methods/methods";
import { Fragment, useState } from "react";
import { Menu, Dialog, Transition } from "@headlessui/react";
import Sidebar from "../sidebar";
import { FiMenu, FiX } from "react-icons/fi";
import { LuLogOut, LuRefreshCw, LuUser } from "react-icons/lu";
import { RxDashboard } from "react-icons/rx";
import { IoChatbubblesOutline, IoSettingsOutline } from "react-icons/io5";
import PinInput from "react-pin-input";
import ApiClient from "../../../methods/api/apiClient";
import socketModel from "../../../models/socketModel";
import { login_success } from "../../../actions/user";
import { useDispatch } from "react-redux";
import loader from "../../../methods/loader";
import { HiOutlineChatBubbleBottomCenter, HiOutlineEnvelope } from "react-icons/hi2";
import { Tooltip } from "antd";
import Swal from "sweetalert2";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Html = ({
  isOpen,
  toggle,
  searchHandle,
  search,
  user,
  isOpen1,
  searchChange,
  clear,
  Logout,
  messageCount,
  staffLoginModal,
  setStaffLoginModal,
}) => {
  const [form, setForm] = useState("")
  const [submit, setSubmit] = useState(false)
  const [syncingCloverRewards, setSyncingCloverRewards] = useState(false)
  const dispatch = useDispatch()

  const handleStaffLogin = (e) => {
    e.preventDefault()
    setSubmit(true)
    if (form?.length !== 4) return
    const payload = {
      loginPin: form,
    }
    loader(true);
    ApiClient.post(`user/staffLogin`, payload).then(async (res) => {
      if (res.success == true) {
        socketModel.emit("user-online", { user_id: user?._id });
        const loginTime = new Date();
        localStorage.setItem("loginTime", loginTime.toISOString());
        localStorage.setItem("token", res?.data?.access_token);
        dispatch(login_success(res?.data));
        setStaffLoginModal(false)
      }
      loader(false);
    });
  }

  const handleSyncCloverRewards = async () => {
    if (syncingCloverRewards) return;

    setSyncingCloverRewards(true);
    try {
      const response = await ApiClient.get("orders/clover/updateDiscount");

      if (response?.success) {
        await Swal.fire({
          title: "Sync completed",
          text: response?.message || "Custom rewards synced successfully.",
          icon: "success",
          confirmButtonColor: "#540C0F",
        });
      }
    } catch (error) {
      console.error("Error syncing Custom rewards:", error);
    } finally {
      setSyncingCloverRewards(false);
    }
  };

  return (<>
    <div id="logoutBtn" onClick={Logout}></div>
    <nav
      component="header"
      className={`${isOpen ? "min-sidebar w-[calc(100%-90px)]" : "w-[calc(100%-280px)] "
        } shadow-btn py-1.5 bg-white border-b  fixed transition-[width] duration-300 ml-auto right-0 z-[999] flex items-center px-2 lg:!px-5
      `}
    >
      <button
        onClick={toggle}
        className="h-7 w-7  md:h-9 md:w-9 shrink-0 shadow-btn hover:shadow-none p-1 rounded-lg border border-gray-100 !text-primary"
      >
        {!isOpen ? (
          <FiMenu className="w-full h-full" />
        ) : (
          <FiX className="w-full h-full" />
        )}
      </button>

      <div className="flex items-center gap-2 lg:gap-4 ml-auto">

        {/* <Tooltip
          placement="top"
          title={syncingCloverRewards ? "Syncing Custom rewards..." : "Sync Custom rewards"}
        >
          <button
            type="button"
            onClick={handleSyncCloverRewards}
            disabled={syncingCloverRewards}
            aria-label="Sync Custom rewards"
            className={`relative flex h-10 w-10 items-center justify-center rounded-xl border border-[#D9DDE3] bg-[#F8FAFC] text-[#540C0F] shadow-sm transition-all ${syncingCloverRewards
              ? "cursor-not-allowed opacity-70"
              : "hover:-translate-y-[1px] hover:border-[#540C0F33] hover:bg-[#FFF7F7] hover:shadow-md"
              }`}
          >
            {syncingCloverRewards ? (
              <span className="inline-flex h-4 w-4 rounded-full border-2 border-[#540C0F33] border-t-[#540C0F] animate-spin" />
            ) : (
              <LuRefreshCw className="text-lg lg:text-xl" />
            )}
          </button>
        </Tooltip> */}

        <Tooltip placement="top" title="Chat">
          <Link to={"/chat"}>
            <div className="relative">
              {messageCount > 0 && (
                <p className="text-[10px] absolute -right-3 -top-1 bg-[#540C0F] h-5 w-5 p-1 flex items-center justify-center text-white rounded-full">
                  <span>{messageCount}</span>
                </p>
              )}

              <HiOutlineChatBubbleBottomCenter className="text-xl lg:text-3xl cursor-pointer " />
            </div>
          </Link>
        </Tooltip>
        <Menu as="div" className="relative">
          <div>
            <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white md:px-3 py-1 text-sm font-semibold text-gray-900 ">
              <div className="flex items-center">
                <div className="flex items-center">
                  <img
                    alt="image"
                    src={methodModel.userImg(user.image)}
                    className="h-10 w-10 lg:h-12 lg:w-12 rounded-full object-cover"
                  />
                  <div className="ml-2 text-left">
                    <b className="capitalize text-xs md:text-sm leading-[20px]">{user.fullName}</b>
                    <p className="grayCls mb-0 text-capitalize">
                      {user.customerRole?.name}
                    </p>
                  </div>
                </div>
                <i
                  className="fa fa-angle-down top-1 relative h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </div>
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0  mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/profile"
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block px-4 py-2 text-sm flex items-center gap-2"
                      )}
                    >
                      <LuUser /> Profile
                    </Link>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/dashboard"
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block px-4 py-2 text-sm flex align-center flex items-center gap-2"
                      )}
                    >
                      <RxDashboard /> Dashboard
                    </Link>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/profile/change-password"
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block px-4 py-2 text-sm flex items-center gap-2"
                      )}
                    >
                      <IoSettingsOutline />
                      Change Password
                    </Link>
                  )}
                </Menu.Item>

                <Menu.Item className="divide-y-1 divide-gray-800 pt-1  mt-2">
                  <p className="border-t"></p>
                </Menu.Item>

                <Menu.Item className="">
                  {({ active }) => (
                    <a
                      type="submit"
                      onClick={() => Logout()}
                      className={classNames(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block w-full px-4 py-2 text-left text-sm ancortag flex items-center gap-2"
                      )}
                    >
                      <LuLogOut /> Logout
                    </a>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
      {isOpen1 ? (
        <div className="w-100 mobi-dropdown">
          <Sidebar />
        </div>
      ) : (
        <></>
      )}
    </nav>
    {/* Staff Login Modal */}
    <Transition appear show={staffLoginModal} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => setStaffLoginModal(true)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/55 " />
        </Transition.Child>
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <img src="assets/img/pin-code.svg" className="h-20 mx-auto mb-6 fill:bg-primary text-primary" />

                <Dialog.Title
                  as="h3"
                  className="text-lg mb-6 text-center font-medium leading-6 text-gray-900"
                >
                  Please enter your pin for login
                </Dialog.Title>
                <form className="flex flex-col items-center justify-center	mx-auto" onSubmit={handleStaffLogin}>
                  <div className="inputs_play">
                    <PinInput
                      length={4}
                      focus
                      secret
                      initialValue={form}
                      type="numeric"

                      onChange={(e) => setForm(e)}
                    />
                    {submit && form?.length !== 4 ?
                      <p className="text-red-600">Pin is required</p>
                      : null}
                  </div>
                  <div className="mt-6 flex items-center justify-center">
                    <button type="submit" className="h-11 rounded-full w-52 font-semibold text-center text-white   hover:opacity-80 transition-all ">
                      Login
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  </>
  );
};

export default Html;
